import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Container, Row, Col } from 'reactstrap'
import YouTube from 'react-youtube';
import {
    Carousel,
    CarouselItem,
    CarouselControl,
    CarouselIndicators,
    CarouselCaption
} from 'reactstrap';

import style from './Home.css'
import './Home.css'


import { setCurrenttab_home } from '../../Actions/Actionexport'
import Gamedisplay from '../Gamedisplay'


var sectionStyle = {



    fontFamily: 'Architects Daughter,  cursive', fontSize: '22px',


};
const opts = {
    height: '90',
    width: '540',
    playerVars: {
        origin:' http://localhost:3000/',
        // https://developers.google.com/youtube/player_parameters
        autoplay: 0,
    },
};


const items = [
    {
        src: 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22800%22%20height%3D%22400%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20800%20400%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_15ba800aa1d%20text%20%7B%20fill%3A%23555%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A40pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_15ba800aa1d%22%3E%3Crect%20width%3D%22800%22%20height%3D%22400%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22285.921875%22%20y%3D%22218.3%22%3EFirst%20slide%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E',
        altText: 'Slide 1',
        caption: '',
        videoId: 'DiUublxnDvQ'
    },
    {
        src: 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22800%22%20height%3D%22400%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20800%20400%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_15ba800aa20%20text%20%7B%20fill%3A%23444%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A40pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_15ba800aa20%22%3E%3Crect%20width%3D%22800%22%20height%3D%22400%22%20fill%3D%22%23666%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22247.3203125%22%20y%3D%22218.3%22%3ESecond%20slide%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E',
        altText: 'Slide 2',
        caption: '',
        videoId: 'blqt0T5soxo'
    },

];
const Home = (props) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);
    const [, setslidemove] = useState(false);

    const next = () => {
        if (animating) return;
        const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    }

    const previous = () => {
        if (animating) return;
        const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    }

    const goToIndex = (newIndex) => {
        if (animating) return;
        setActiveIndex(newIndex);
    }
    useEffect(() => {
        props.setcurrenttab_home()
    }, [props])
    const _onReady = (event) => {
        // access to player in all event handlers via event.target
        event.target.pauseVideo();
    }
  

    const slides = items.map((item) => {
        return (
            <CarouselItem
                onExiting={() => setAnimating(true)}
                onExited={() => setAnimating(false)}
                key={item.src}
            >
                <YouTube className="fluid" videoId={item.videoId} opts={opts} onReady={_onReady} onPlay={() => {
                    setslidemove(true); setActiveIndex(activeIndex)
                }
               
                } />
                
                <br></br>
                <br></br>
                <br></br>
                
                <CarouselCaption captionText={item.caption} captionHeader={item.caption} />
            </CarouselItem>
        );
    });

    return (
        <React.Fragment>



            <Container fluid={true} className=" full" >

                <Row className="md-5  " >

                </Row>

                <Row className="mt-5 md-5 " >
                    <Col>
                        <div style={{ sectionStyle }}>
                            <h1>Vanakkam</h1>
                    I make games and stufffffff!
                    <hr>
                            </hr>
                            <h6> I'm  indie game developer released games for mobiles .check out  my games below. </h6>


                        </div>
                    </Col>
                </Row>

            </Container>
        
            <Container fluid={true} className="slidecolor" >
<Row>

</Row>
                <Row className="mt-5" lg='3' xs='1'>
               
                    <Col xs={{order:1}} lg={{order:0}}>
                  

                        <Gamedisplay height="440" animationName="coolerfrog_web" titlename="Buggy frog" download="download now"
                        content=" Buggy frog is casual kids game available in google play store .Join your hungry buggy frog and eat the bugs to save your garden.
                  This game has got a single level where you have to save your flowers from the bug
                  just by touching the bugs and eating it." ></Gamedisplay >
                    </Col>
                    <Col  className="mt-5" style={{fontFamily:'Syne Mono,monospace' ,paddingTop:'150px'}} xl={{order:0}} xs={{order:0}}>
<h1>checkout my games !!</h1>
</Col>
                    <Col >
                    <Gamedisplay animationName="frogwave" titlename="Buggy frog" download="download now"
                        content=" Buggy frog is casual kids game available in google play store .Join your hungry buggy frog and eat the bugs to save your garden.
                  This game has got a single level where you have to save your flowers from the bug
                  just by touching the bugs and eating it."></Gamedisplay >
                   
                   
                   
                       </Col>
                     
                </Row>
                <hr></hr>
                <Row>
<Col lg='5' className="mt-5" >
<h1>Subscribe to my channel !!</h1>
</Col>
</Row>
                <Row className="mt-5" >

<Col >
    <Carousel
        activeIndex={activeIndex}
        next={next}
        previous={previous}
        interval={false}
        style={{height:'500px'}}
    >
        <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} cssModule={style}  />
        {slides}
        <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} cssModule={style} />
        <CarouselControl direction="next" directionText="Next" onClickHandler={next} cssModule={style} />
    </Carousel>

</Col>

</Row>

            </Container>
            <Container fluid={true} className="slidecolor">

               
            </Container>
        </React.Fragment>

    )
}

const mapdispatchtomethod = (dispatch) => {
    return {
        setcurrenttab_home: () => dispatch(setCurrenttab_home())
    }
}
export default connect(null, mapdispatchtomethod)(Home) 